const initIMask = (input) => {
    if (!input) return
    IMask(input, {
        mask: '+{7} (000) 000-00-00',
        prepare: (appended, masked) => {
            if (appended === '8' && masked.value === '') {
                return '+7';
            }
            return appended;
        },
    });
}
